import { ColorTokens, BorderRadiusTokens, SizeTypeTokens, FontSizeTokens, InputTypeToken, } from '@voltmoney/schema';
export const inputTypeTokensMap = {
    [InputTypeToken.DEFAULT]: {
        fontSize: FontSizeTokens.SM,
        color: ColorTokens.Grey_500,
        bgColor: ColorTokens.Transparent,
        borderColor: ColorTokens.Grey_200,
        borderRadius: BorderRadiusTokens.BR1,
        paddingVertical: SizeTypeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [InputTypeToken.OTP]: {
        fontSize: FontSizeTokens.SM,
        color: ColorTokens.Grey_500,
        bgColor: ColorTokens.Transparent,
        borderColor: ColorTokens.Grey_200,
        borderRadius: BorderRadiusTokens.BR1,
        paddingVertical: SizeTypeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [InputTypeToken.MOBILE]: {
        fontSize: FontSizeTokens.SM,
        color: ColorTokens.Grey_500,
        bgColor: ColorTokens.Transparent,
        borderColor: ColorTokens.Grey_200,
        borderRadius: BorderRadiusTokens.BR1,
        paddingVertical: SizeTypeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [InputTypeToken.EMAIL]: {
        fontSize: FontSizeTokens.SM,
        color: ColorTokens.Grey_500,
        bgColor: ColorTokens.Transparent,
        borderColor: ColorTokens.Grey_200,
        borderRadius: BorderRadiusTokens.BR1,
        paddingVertical: SizeTypeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [InputTypeToken.SEARCH]: {
        fontSize: FontSizeTokens.SM,
        color: ColorTokens.Grey_500,
        bgColor: ColorTokens.Transparent,
        borderColor: ColorTokens.Grey_200,
        borderRadius: BorderRadiusTokens.BR1,
        paddingVertical: SizeTypeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    [InputTypeToken.MULTILINE]: {
        fontSize: FontSizeTokens.SM,
        color: ColorTokens.Grey_500,
        bgColor: ColorTokens.Transparent,
        borderColor: ColorTokens.Grey_200,
        borderRadius: BorderRadiusTokens.BR1,
        paddingVertical: SizeTypeTokens.LG,
        paddingHorizontal: SizeTypeTokens.XL,
    },
    // [InputTypeToken.CALENDAR]: {
    // 	fontSize: FontSizeTokens.SM,
    // 	color: ColorTokens.Grey_500,
    // 	bgColor: ColorTokens.Transparent,
    // 	borderColor: ColorTokens.Grey_200,
    // 	borderRadius: BorderRadiusTokens.BR1,
    // 	paddingVertical: SizeTypeTokens.LG,
    // 	paddingHorizontal: SizeTypeTokens.XL,
    // },
};
